import { isObject, camelCase, snakeCase, isArray, isString } from 'lodash';

export const keyValuesToCamelCase = (
  o: Record<string, any>,
): Record<string, any> => {
  if (isArray(o)) {
    return o.map((item: any) => {
      return keyValuesToCamelCase(item);
    });
  }
  if (isObject(o)) {
    const n: Record<string, any> = {};
    Object.keys(o).forEach((key) => {
      n[camelCase(key)] = keyValuesToCamelCase(o[key]);
    });
    return n;
  }
  if (isString(o)) {
    return camelCase(o) as unknown as Record<string, any>;
  }

  return o;
};

export const keysToCamel = (o: Record<string, any>): Record<string, any> => {
  if (isArray(o)) {
    return o.map((item: any) => {
      return keysToCamel(item);
    });
  }
  if (isObject(o)) {
    const n: Record<string, any> = {};
    Object.keys(o).forEach((key) => {
      n[camelCase(key)] = keysToCamel(o[key]);
    });
    return n;
  }

  return o;
};

export const keysToSnakeCase = (
  o: Record<string, any>,
): Record<string, any> => {
  if (isArray(o)) {
    return o.map((item: any) => {
      return keysToSnakeCase(item);
    });
  }
  if (isObject(o)) {
    const n: Record<string, any> = {};
    Object.keys(o).forEach((key) => {
      n[snakeCase(key)] = keysToSnakeCase(o[key]);
    });
    return n;
  }

  return o;
};
